import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'InputSelect',
  props: {
    filter: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    filterState: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    type: {
      type: String,
      default: 'checkbox'
    },
    styling: {
      type: String,
      default: 'check'
    }
  },
  computed: {
    selectedValues: function selectedValues() {
      return this.filterState[this.filter.id] || [];
    }
  },
  methods: {
    updateValue: function updateValue(optionValue) {
      this.$emit('change', {
        filter: this.filter,
        optionValue: optionValue
      });
    }
  }
};